import React from "react";
import { Placeholder } from "semantic-ui-react";

export const PlaceholderTabla = ({ filas = 4 }) => {
  return (
    <Placeholder fluid className="m-2">
      <Placeholder.Paragraph>
        <Placeholder.Line length="full" className="mb-10" />
        {[...Array(filas)].map((x, y) => (
          <Placeholder.Line
            length="full"
            className="mb-15"
            key={`linea${y}`}
          ></Placeholder.Line>
        ))}
      </Placeholder.Paragraph>
    </Placeholder>
  );
};

export const PlaceholderInput = () => {
  return (
    <>
      <Placeholder fluid className="m-2 flex-grow-1">
        <Placeholder.Line length="full" className="mb-10" />
      </Placeholder>
    </>
  );
};

export const PlaceholderColumnas = ({
  keys = "k",
  columnas = 3,
  filas = 3,
}) => {
  let placeholders = [];
  let filasPlaceholders = [];
  let keyPlaceholder = 0;
  for (let i = 0; i < filas; i++) {
    filasPlaceholders.push(
      <Placeholder.Line
        key={"" + keyPlaceholder}
        length="full"
        className="mb-10"
      />
    );
    keyPlaceholder++;
  }
  for (let i = 0; i < columnas; i++) {
    placeholders.push(
      <Placeholder key={"" + keyPlaceholder} fluid className="m-2 flex-grow-1">
        {filasPlaceholders}
      </Placeholder>
    );
    keyPlaceholder++;
  }
  return (
    <>
      <div className="d-flex flex-row">{placeholders}</div>
    </>
  );
};
